/* DARKGROUND DESIGN SYSTEM · motion (see dg-motion.css)
   Starts as soon as the page structure is ready (not after videos load), so everything below the screen is
   prepared before the visitor scrolls. A second pass after full load picks up anything that appeared later.
   Elements start once they are a little inside the screen, in cascade (longer gaps on the home page).
*/
(function () {
  'use strict';
  if (window.__dgMotion) return;
  window.__dgMotion = true;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || (window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window)) return;

  var main = document.getElementById('MainContent');
  var isHome = !!(main && main.getAttribute('data-template') === 'index');
  var GAP = isHome ? 150 : 100;
  var CLEAN = isHome ? 2300 : 1700;

  var SKIP = '.dg-hslides, .dg-tl, .dg-marquee, .dg-hrel__grid, [data-dg-sticky-bar], .dg-reveal, [data-dgm-skip], .dg-cart-assure, cart-drawer-component, header, footer';
  var GROUPS = [
    '[class*="__grid"] > *', '.dg-cards > *', '.dg-stats > *', '.dg-hidx__list > *', '.dg-hlabel__links > *',
    '.dg-faq__list > *', '.dg-faq > details', '.dg-list > *', '.dg-hfeat__points > *', '.dg-cfilters', '.dg-cgrid__bar'
  ].join(', ');
  var SINGLES = [
    '.dg-label', '.dg-h2', '.dg-h3', '.dg-display', '.dg-lead', '.dg-hhead__link', '.dg-hfeat__title', '.dg-hfeat__price',
    '.dg-hfeat__ctas', '.dg-hlabel__embed', '.dg-hjoin__form', '.dg-hjoin__note', '.dg-himpact__title', '.dg-hdemo__title',
    '.dg-hprod__arrows', '.dg-hprod__progress', '.dg-btn', 'h2', 'h3', '.dg-small'
  ].join(', ');
  var MEDIA = '.dg-hfeat__media, .dg-section figure, .dg-section .dg-media, .dg-bundle-row, .dg-ab, .dg-compare, .dg-pair';

  var io = new IntersectionObserver(function (entries) {
    var batch = entries.filter(function (e) { return e.isIntersecting; }).map(function (e) { return e.target; });
    batch.sort(function (a, b) {
      var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect();
      return (ra.top - rb.top) || (ra.left - rb.left);
    });
    batch.forEach(function (el, k) {
      io.unobserve(el);
      var d = Math.min(k, 7) * GAP;
      el.style.setProperty('--dgm-d', d + 'ms');
      requestAnimationFrame(function () { el.classList.add('is-dgm-in'); });
      setTimeout(function () {
        el.removeAttribute('data-dgm');
        el.classList.remove('is-dgm-in');
        el.style.removeProperty('--dgm-d');
      }, d + CLEAN);
    });
  }, { threshold: 0.15, rootMargin: isHome ? '0px 0px -14% 0px' : '0px 0px -8% 0px' });

  function tag(el, kind) {
    if (el.hasAttribute('data-dgm') || el.closest(SKIP)) return;
    var p = el.parentElement;
    while (p) { if (p.hasAttribute && p.hasAttribute('data-dgm')) return; p = p.parentElement; }
    var r = el.getBoundingClientRect();
    if (!r.width && !r.height) return;
    if (r.top < (window.innerHeight || 800) * 0.92) return;
    el.setAttribute('data-dgm', kind || '');
    io.observe(el);
  }

  function scan(root) {
    var sections = (root || document).querySelectorAll('#MainContent .dg');
    sections.forEach(function (sec) {
      if (sec.closest(SKIP)) return;
      sec.querySelectorAll(MEDIA).forEach(function (el) { tag(el, 'media'); });
      sec.querySelectorAll(GROUPS).forEach(function (el) { tag(el, ''); });
      sec.querySelectorAll(SINGLES).forEach(function (el) { tag(el, ''); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); });
  else scan(document);
  window.addEventListener('load', function () { setTimeout(function () { scan(document); }, 80); });
})();
